import {
  getProductImage,
  getProductPrice,
  getProductTitle,
} from "./beerFinder.helpers";

export default function BeerFinderProduct({ role, text, product, t, onOpenProduct }) {
  if (!product) return null;

  const title = getProductTitle(product);
  const image = getProductImage(product);
  const price = getProductPrice(product, t);

  return (
    <div
      className="beerFinderProduct"
      role="button"
      tabIndex={0}
      onClick={() => onOpenProduct?.(product)}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onOpenProduct?.(product);
        }
      }}
    >
      <div className="beerFinderProductInfo">
        <p className="beerFinderProductRole">{role}</p>
        <h3>{title}</h3>
        <p>{text}</p>

        {price ? <strong>{price}</strong> : null}
      </div>

      {image ? (
        <img
          className="beerFinderProductImage"
          src={image}
          alt={title}
          loading="lazy"
        />
      ) : null}
    </div>
  );
}